import { render } from "@/components/pages/home/Home.html?vue&type=template&id=37b29a77&external"
import script from "@/components/pages/home/Home.js?vue&type=script&lang=js&external"
export * from "@/components/pages/home/Home.js?vue&type=script&lang=js&external"

import "@/components/pages/home/Home.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__